import { Routes } from '@angular/router';

import routeData from './components/home/route-data';

export default <Routes>[
  {
    path: '',
    loadComponent: async () => import('./components/home/home.component'),
    data: routeData,
    children: [
      { path: '', loadComponent: async () => import('./components/overview/overview.component') },
      { path: 'campaigns', loadComponent: async () => import('./components/campaigns/campaigns.component') },
      { path: 'campaigns/:id', loadComponent: async () => import('./components/campaign/campaign.component') },
      { path: 'users', loadComponent: async () => import('./components/transactions/transactions.component') }
    ]
  }
];
